__turbopack_context__.v({
  "active": "index-module__JwY77q__active",
  "icon": "index-module__JwY77q__icon",
  "item": "index-module__JwY77q__item",
  "label": "index-module__JwY77q__label",
  "progression": "index-module__JwY77q__progression",
  "progressionIcon": "index-module__JwY77q__progressionIcon",
});
